import React from 'react';
import { Branch, Category } from '../../../../types';

/* نفس StepProps بالظبط */
interface StepProps {
  formData: any;
  categories: Category[];
  branches: Branch[];
  imagePreview?: string | null;
}

/* Component مساعد صغير */
const Info = ({ label, value }: { label: string; value: any }) => (
  <div>
    <span className="text-sm text-gray-500">{label}</span>
    <p className="font-medium">{value || 'Not set'}</p>
  </div>
);

// Step 7: Review & Submit
const Step7ReviewSubmit: React.FC<StepProps> = ({
  formData,
  categories,
  branches,
  imagePreview,
}) => {
  const badgeOptions = [
    { value: '', label: 'No Badge' },
    { value: 'New', label: 'New' },
    { value: 'Bestseller', label: 'Bestseller' },
    { value: 'Sale', label: 'Sale' },
    { value: 'Limited', label: 'Limited Edition' },
    { value: 'Featured', label: 'Featured' },
  ];

  const getCategoryName = () =>
    categories.find(c => c.id === Number(formData.category))?.name || 'Not selected';

  const getBranchName = () =>
    branches.find(b => b.id === Number(formData.branchId))?.name || 'Not selected';

  const getBadgeLabel = () =>
    badgeOptions.find(b => b.value === formData.badge)?.label || 'No badge';

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-gray-800">
        Review Product Information
      </h3>
      <p className="text-gray-600">
        Please review all information before submitting
      </p>

      <div className="space-y-6">
        {/* Product Info */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h4 className="font-medium text-gray-900 mb-4">
            Product Information
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Info label="Product Name" value={formData.name} />
            <Info label="SKU" value={formData.sku} />
            <Info label="Short Description" value={formData.shortDescription} />
            <Info label="Category" value={getCategoryName()} />
          </div>
        </div>

        {/* Pricing & Features */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h4 className="font-medium text-gray-900 mb-4">
            Pricing & Features
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Info label="Base Price" value={`$${formData.basePrice || '0.00'}`} />
            <Info
              label="Featured Product"
              value={formData.isFeatured ? 'Yes' : 'No'}
            />
            <Info label="Badge" value={getBadgeLabel()} />
            <Info
              label="Image"
              value={imagePreview ? 'Uploaded ✓' : 'Not uploaded'}
            />
          </div>
        </div>

        {/* Branch Assignment */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h4 className="font-medium text-gray-900 mb-4">
            Branch Assignment
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Info label="Branch" value={getBranchName()} />
            <Info label="Branch Price" value={`$${formData.price || '0.00'}`} />
            <Info label="Stock" value={formData.stock || '0'} />
            <Info
              label="Available"
              value={formData.isAvailable ? 'Yes' : 'No'}
            />
          </div>
        </div>

        {/* Branch Descriptions */}
        {(formData.branchDescription || formData.branchDescriptionAR) && (
          <div className="bg-white rounded-lg border border-gray-200 p-6">
            <h4 className="font-medium text-gray-900 mb-4">
              Branch Descriptions
            </h4>

            <div className="space-y-4">
              {formData.branchDescription && (
                <div>
                  <span className="text-sm text-gray-500">
                    English Description
                  </span>
                  <p className="mt-1 text-gray-700">
                    {formData.branchDescription}
                  </p>
                </div>
              )}

              {formData.branchDescriptionAR && (
                <div>
                  <span className="text-sm text-gray-500">
                    Arabic Description
                  </span>
                  <p className="mt-1 text-gray-700 text-right" dir="rtl">
                    {formData.branchDescriptionAR}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step7ReviewSubmit;
